import { AppBar, SxProps, Theme, Toolbar } from '@mui/material';
import { ABGLogo } from 'shared/logos';

const rootStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
};

export function HeaderPublic() {
  return (
    <AppBar sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} position='static'>
      <Toolbar sx={rootStyles}>
        <ABGLogo />
      </Toolbar>
    </AppBar>
  );
}
